
<template>
  <div class="layout">
    <Layout>
      <yn-header></yn-header>
      <Layout>
        <Sider>
          <yn-slider></yn-slider>
        </Sider>
        <Layout :style="{paddingLeft: '20px'}">
          <Content :style="{padding: '10px 20px', minHeight: '280px', background: '#fff'}">
            <yn-tags></yn-tags>
            <div class="table">
              <!-- <Table :loading='loading' border stripe size="small" :columns="columns7" :data="data6"></Table>
              <Page class="page" :total="40" size="small" show-elevator show-sizer /> -->
              <router-view></router-view>
            </div>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import YnHeader from "./YnHeader.vue";
import YnSlider from "./YnSlider.vue";
import YnTags from "./YnTags.vue";

export default {
  data() {
    return {
      name:"test",
      loading:false
    }
  },
  components: { YnHeader, YnSlider, YnTags },
  mounted() {
    
  },
  methods: {}
};
</script>

<style scoped>
.layout {
  background: #f5f7f9;
  position: relative;
  overflow: hidden;
  height: 100%;
}

.ivu-layout-sider {
  background-color: #fff;
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
  background-color: #f2f2f2;
}
.table{
  margin-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/index/Index.vue